const API_BASE_URL = process.env.BASE_URL

export const ECOMMERCE_ENDPOINTS = {
    PLATFORMS: API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/platforms/",
    PLATFORM_AUTHORIZE:
        API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/platforms/{platform}/authorize/",
    CONNECTIONS: API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/connections/",
    CONNECTION_DETAILS: API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/connections/{id}/",
    CONNECTION_TEST: API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/connections/{id}/test/",
    CONNECTION_REGISTER_WEBHOOKS:
        API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/connections/{id}/register-webhooks/",
    CONNECTION_CHECK_SCOPES:
        API_BASE_URL + "/{service_company_slug}/integrations/ecommerce/api/connections/{id}/check-scopes/",
}
